/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbDeleteRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getCmdbIconByIdUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbIconByIdUrl.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { IconType, ActionApi } from './ActionApi.types.tsx';

export const deleteIcon =
	(icon: IconType): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		setState({
			...state,
			icons: { ...state.icons, deleteLoading: true },
		});

		try {
			await performCmdbDeleteRequest(getCmdbIconByIdUrl(workspaceId, icon.id));

			setState({
				...state,
				icons: {
					...state.icons,
					deleteLoading: false,
					data: state.icons.data ? state.icons.data.filter(({ id }) => id !== icon.id) : undefined,
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), 'deleteIcon succeeded');
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...state,
				icons: { ...state.icons, deleteLoading: false, deleteError: error },
			});

			fireCmdbErrorAnalytics({
				meta: {
					id: 'deleteIcon',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'astral',
				},
				error,
			});

			throw error;
		}
	};
